import { MatSpinner } from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import { MatAnchor, MatButtonModule, MatButton } from "@angular/material/button";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { Collaborateur } from '../../../shared/model';
import { CollaborateurService } from '../../service/collaborateur-service';
import { NgIf, UpperCasePipe } from '@angular/common';
import { ToastrService } from '../../../shared/services/toastr-service';
import { TitleComponent } from '../../../shared/components/title-component/title-component';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { ChangeDetectionStrategy, Component, inject, model, signal, ViewChild } from '@angular/core';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { Router } from '@angular/router';
import { DatabaseConnection } from '../../../shared/services/database-connection';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Collaborateur
}

@Component({
  selector: 'app-collaborateur-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    MatSpinner
],
  templateUrl: './collaborateur-component.html',
  styleUrl: './collaborateur-component.css',
})


export class CollaborateurComponent {

  displayedColumns: string[] = ['id', 'logo', 'collaborateur', 'owner', 'adresse', 'status', 'actions'];
  dataSource!: MatTableDataSource<Collaborateur>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  currentCollaborateur = signal<Collaborateur>(new Collaborateur())
  readonly dialog = inject(MatDialog);
  API_STORAGE = inject(DatabaseConnection).storageConnection.value

  loading = false
  constructor(
    private collaborateurService : CollaborateurService,
    private toastr : ToastrService,
    private router : Router,
    private sweetAlert : SweetAlertService){
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource<Collaborateur>([]);
  }

  ngOnInit(): void {
    this.loading = true
    this.collaborateurService.getAll().subscribe({
      next : (res) =>{
        console.log(res);
        this.dataSource.data = res
        this.loading = false
      },
      error : (err) =>{
        this.loading = false
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openAddCollaborateurModal(){
    const data : ModalDataI = {
      title : 'Ajouter un collaborateur',
      data : new Collaborateur()
    }

    const dialogRef = this.dialog.open(CollaborateurComponentModal, {
      width : '1000px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Collaborateur) => {

      if (result?.id != undefined) {
        const data : Collaborateur[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("Le collaborateur "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdate(collaborateur : Collaborateur){
    this.currentCollaborateur.set(collaborateur)

    const data : ModalDataI = {
      title : 'Modifier le collaborateur ' + collaborateur.name,
      update : true,
      data : this.currentCollaborateur()
    }

    const dialogRef = this.dialog.open(CollaborateurComponentModal, {
      width : '1000px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Collaborateur) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("Le collaborateur "+ result.name + " à été modifie")
      }
    });
  }

  confirm(coutier : Collaborateur){
    this.sweetAlert
    .confirm('Etez-vous sur de vouloir supprimer le collaborateur '+ coutier.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.collaborateurService.delete(coutier.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != coutier.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChange(collaborateur : Collaborateur){
    const title = collaborateur.disable?'Activation':'Desactivation'
    const action = collaborateur.disable?'activer':'desactiver'
    this.sweetAlert.confirm('Etez-vous sur de vouloir ' + action)
    .then((res) =>{
      if(res.isConfirmed){
        this.collaborateurService.changeStatus(collaborateur.id).subscribe({
          next : (result) =>{
            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data
            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  goToDetails(collaborateur : Collaborateur){
    this.router.navigateByUrl('/collaborateurs/'+collaborateur.id)
  }
}

@Component({
  selector: 'app-collaborateur-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgIf,
    MatTooltip,
    MatIcon
  ],
  templateUrl: '../modal/modal-collaborateur.html',
  styleUrl: '../modal/modal-collaborateur.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollaborateurComponentModal {
  readonly dialogRef = inject(MatDialogRef<CollaborateurComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly collaborateur = model(this.inputData.data!);

  collaborateurForm : FormGroup = new FormGroup({})
  fileName = '';
  selectedFile: File | null = null;

  constructor(
    private fb : FormBuilder,
    private collaborateurService : CollaborateurService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.collaborateurForm = this.fb.group({
      name : ['', [Validators.required]],
      code : ['', [Validators.required]],
      owner : ['', [Validators.required]],
      adresse : ['', [Validators.required]],
      logo : ['', [Validators.required]],
      tel : [''],
      email : [''],
      niu : [''],
      rccm : [''],
      agrement : [''],
      bp : [''],
      capital : ['', [Validators.required]]
    })
  }

  ngAfterViewInit(): void {
    this.collaborateurForm.patchValue(this.inputData?.data!)
    this.collaborateurForm.get('name')?.valueChanges.subscribe((val : string) =>{
      if(val){
        const code = val.slice(0, 2).toUpperCase();
        this.collaborateurForm.get('code')?.setValue(code)
      }
    })
  }

  resetForm(){
    this.collaborateurForm.patchValue({
      name : '',
      owner : '',
      code : '',
      adresse : '',
      logo : '',
      tel :'',
      email : '',
      niu : '',
      rccm : '',
      agrement : '',
      bp : '',
      capital : '',
    })
    this.selectedFile = null
    this.fileName = ''
  }


  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const files: FileList | null = element.files;
    if (files && files.length > 0) {

      console.log(files[0]);

      this.selectedFile = files[0];
      this.fileName = this.selectedFile.name;
      this.collaborateurForm.get('logo')?.setValue(this.selectedFile.name)
      // You can now proceed to upload the file using HttpClient
    } else {
      this.fileName = '';
      this.selectedFile = null;
    }
  }

  onAdd(){
    const data = new FormData();
    data.append('name' , this.collaborateurForm.get('name')?.value)
    data.append('owner' , this.collaborateurForm.get('owner')?.value)
    data.append('code' , this.collaborateurForm.get('code')?.value)
    data.append('adresse' , this.collaborateurForm.get('adresse')?.value)
    data.append('capital' , this.collaborateurForm.get('capital')?.value)
    data.append('niu' , this.collaborateurForm.get('niu')?.value)
    data.append('rccm' , this.collaborateurForm.get('rccm')?.value)
    data.append('agrement' , this.collaborateurForm.get('agrement')?.value)
    data.append('bp' , this.collaborateurForm.get('bp')?.value)
    data.append('email' , this.collaborateurForm.get('email')?.value)
    data.append('tel' , this.collaborateurForm.get('tel')?.value)
    data.append('logo', (this.selectedFile as Blob), this.selectedFile?.name)

    this.collaborateurService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = new FormData();
    data.append('name' , this.collaborateurForm.get('name')?.value)
    data.append('owner' , this.collaborateurForm.get('owner')?.value)
    data.append('code' , this.collaborateurForm.get('code')?.value)
    data.append('adresse' , this.collaborateurForm.get('adresse')?.value)
    data.append('capital' , this.collaborateurForm.get('capital')?.value)
    data.append('niu' , this.collaborateurForm.get('niu')?.value)
    data.append('rccm' , this.collaborateurForm.get('rccm')?.value)
    data.append('agrement' , this.collaborateurForm.get('agrement')?.value)
    data.append('bp' , this.collaborateurForm.get('bp')?.value)
    data.append('email' , this.collaborateurForm.get('email')?.value)
    data.append('tel' , this.collaborateurForm.get('tel')?.value)
    data.append('_method', 'PUT')

    if(this.selectedFile != null)
      data.append('logo', (this.selectedFile as Blob), this.selectedFile?.name)

    this.collaborateurService.update(data, this.inputData.data?.id??'').subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }


}

